import React, { ReactNode } from "react";
import { useLocation } from "react-router-dom";

interface AppLayoutProps {
    children: ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
    const location = useLocation();

    // Determine wheter this is the scheduler page
    const isScheduler = location.pathname.startsWith("/scheduling");

    return (
        <div className={`app-container ${isScheduler ? "layout-scheduler" : ""}`}>
            {children}
        </div>
    );
}

export default AppLayout;